import { render, staticRenderFns } from "./LifeQuote.vue?vue&type=template&id=95e369c8&scoped=true&"
import script from "./LifeQuote.vue?vue&type=script&lang=js&"
export * from "./LifeQuote.vue?vue&type=script&lang=js&"
import style0 from "./LifeQuote.vue?vue&type=style&index=0&id=95e369c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e369c8",
  null
  
)

export default component.exports